webpackJsonp([19],{

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_constants__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__constants_constants__);

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.config.productionTip = false;

  Vue.prototype.$eventHub = new Vue(); // Global event bus

  Vue.prototype.$ponceConfig = {
    checkStatus: function checkStatus(state) {
      switch (state) {
        case __WEBPACK_IMPORTED_MODULE_0__constants_constants__["STATES"].IRRIGATING:
          return '#00d166';
        case __WEBPACK_IMPORTED_MODULE_0__constants_constants__["STATES"].MOVING:
          return '#4F5AB0';
        case __WEBPACK_IMPORTED_MODULE_0__constants_constants__["STATES"].OFF:
          return '#999';
        case __WEBPACK_IMPORTED_MODULE_0__constants_constants__["STATES"].FAILURE:
          return '#f93a2f';

      }
    },

    organizationDemoId: 999,
    sortByEntityName: function sortByEntityName(array) {
      return array.sort(function (a, b) {
        if (a.campaign.entityName < b.campaign.entityName) {
          return -1;
        }
        if (a.campaign.entityName > b.campaign.entityName) {
          return 1;
        }
        return 0;
      });
    },

    numberRules: [function (v) {
      return !!v || 'El campo es requerido';
    }, function (v) {
      return (/^[+]?\d+([.]\d+)?$/.test(v) || 'Solo números por favor'
      );
    }],
    phoneRules: [function (v) {
      return !!v || 'El teléfono es requerido';
    }, function (v) {
      return (/^[+]{1}[0-9]{13}$/.test(v) || 'Formato requerido: +549223XXXXXXX'
      );
    }],
    requiredRules: [function (v) {
      return !!v || 'Este campo es requerido';
    }],
    /* latLonRules: [
      v => !!v || 'La latitud y Longitud es requerida',
      v => /^(\-?\d+(\.\d+)?).\s*(\-?\d+(\.\d+)?)$/.test(v) || 'Formato requerido: (-)38.002625'
    ], */
    numberOptionalRules: [function (v) {
      return (/^[+]?\d+([.]\d+)?$/.test(v) || 'Solo números por favor'
      );
    }],
    passwordRules: [function (v) {
      return !!v || 'La contraseña es requerida';
    }, function (v) {
      return v && v.length >= 8 || 'La contraseña debe contener al menos 8 caracteres';
    }],
    emailRules: [function (v) {
      return !!v || 'El e-mail es requerido';
    }, function (v) {
      return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'El e-mail debe ser valido'
      );
    }],
    lotNameRules: [function (v) {
      return !!v || 'El nombre es requerido';
    }, function (v) {
      return v && v.length <= 21 || 'El nombre no puede superar los 21 caracteres';
    }],
    equipmentNameRules: [function (v) {
      return !!v || 'El nombre es requerido';
    }, function (v) {
      return v && v.length <= 16 || 'El nombre no puede superar los 16 caracteres';
    }],
    organizationTypes: [{ text: 'Productor', value: 'grower' }, { text: 'Empresa', value: 'company' }, { text: 'Corporación', value: 'corporation' }],
    deviceMode: [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }],
    equipmentTypes: [{ text: 'Pivot', value: 1 }, { text: 'Avance Frontal', value: 2 }]
  };
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.filter('capitalize', function (value) {
    if (!value) {
      return '';
    }
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  });

  Vue.filter('number', function (value) {
    return value ? parseFloat(value.toFixed(3)) : value;
  });
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(76);
// import { EventBus } from './event-bus.js';

window.addEventListener('online', function () {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit('setIsOnline', true);
  var isUploading = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.isUploading;
  if (!isUploading) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].dispatch('uploadStoreEvents');
  }
});
window.addEventListener('offline', function () {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].commit('setIsOnline', false);
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var firebase = __webpack_require__(201).default;

var firebaseConfig = {
  apiKey: "AIzaSyDEi2wgWpANAY4sttulylcvbtSfQ1Oxw88",
  authDomain: "ponce-development-32f24.firebaseapp.com",
  databaseURL: "https://ponce-development-32f24.firebaseio.com",
  projectId: "ponce-development-32f24",
  storageBucket: "ponce-development-32f24.appspot.com",
  messagingSenderId: "344099911530",
  appId: "1:344099911530:web:ab25d141447c49fa5c9713",
  measurementId: "G-SGTD50BBW2"
};

var app = firebase.initializeApp(firebaseConfig);

/* unused harmony default export */ var _unused_webpack_default_export = (app);

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueRegister; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_apollo__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_browser_geolocation__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_browser_geolocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_browser_geolocation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datetime__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datetime_dist_vue_datetime_css__);








// List of components
var AlertCmp = function AlertCmp() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 291));
};
var ToolbarCmp = function ToolbarCmp() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 293));
};
var CurrentCycle = function CurrentCycle() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 281));
};
var DeviceMapPivot = function DeviceMapPivot() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 283));
};
var Timeline = function Timeline() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 284));
};
var DeviceActions = function DeviceActions() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 282));
};
var SnackbarCmp = function SnackbarCmp() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 285));
};
var ComingSoonModal = function ComingSoonModal() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 292));
};

var VueRegister = function VueRegister() {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_apollo__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_datetime__["Datetime"]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_browser_geolocation___default.a);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
    load: {
      key: "AIzaSyAz74EWGQQQGrZU5cMFSoT8NeaQlyNvc0s"
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$log = console.log;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-alert', AlertCmp);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('datetime', __WEBPACK_IMPORTED_MODULE_5_vue_datetime__["Datetime"]);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-toolbar', ToolbarCmp);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('current-cycle', CurrentCycle);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('device-map-pivot', DeviceMapPivot);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('timeline', Timeline);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('device-actions', DeviceActions);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('app-snackbar', SnackbarCmp);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('coming-soon-modal', ComingSoonModal);

  return __WEBPACK_IMPORTED_MODULE_0_vue__["default"];
};

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_guard__ = __webpack_require__(176);


var Home = function Home() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 290));
};
var Signup = function Signup() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 296));
};
var DeviceCreation = function DeviceCreation() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 289));
};
var DeviceDetail = function DeviceDetail() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 288));
};
var Signin = function Signin() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 295));
};
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 286));
};
var Equipments = function Equipments() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 287));
};

var UserInfo = function UserInfo() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 297));
};
var NewOrganization = function NewOrganization() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 294));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/newOrganization',
    name: 'NewOrganization',
    component: NewOrganization,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/signup',
    name: 'Signup',
    component: Signup
  }, {
    path: '/signup2',
    name: 'Signup2',
    component: Signup,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/deviceCreation',
    name: 'Device',
    component: DeviceCreation,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/deviceDetail/:id',
    name: 'DeviceDetail',
    component: DeviceDetail,
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/signin',
    name: 'Signin',
    component: Signin,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/userInfo',
    name: 'UserInfo',
    component: UserInfo,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }, {
    path: '/equipments',
    name: 'Equipments',
    component: Equipments,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_2__auth_guard__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ALL_USERS_QUERY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ALL_DEVICE_TYPES_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ALL_CROP_TYPES_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HASH_ORGANIZATION_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SIGNIN_USER_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_ORGANIZATION_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DISCONNECT_USER_FROM_ORGANIZATION_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISCONNECT_ORGANIZATION_FROM_USER_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CREATE_DEVICE_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CREATE_USER_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_ORGANIZATION_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_QUERY; });
/* unused harmony export DEMO_QUERY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DEVICE_DETAIL_QUERY; });
/* unused harmony export ORGANIZATION_DEVICES_QUERY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DEVICES_FAILING_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ALL_DEVICES_TIMELINE_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_USER_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_USER_ORGANIZATION_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_USER_ROLE_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_DEVICE_ORGANIZATION_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_ORGANIZATION__ADMIN_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ALL_ROLES_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DEVICE_TIMELINE_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ALL_STATES_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ALL_FAILTYPES_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_EVENT_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_IRRIGATION_ORDER_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_FAILTYPE_EVENT_MUTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_DEVICE_EVENT_MUTATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__constants_constants__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query AllUsersQuery($first: Int, $skip: Int) {\n    allUsers(first: $first, skip: $skip) {\n      id\n      name\n      Organization {\n        name\n        id\n      }\n    }\n  }'], ['\n  query AllUsersQuery($first: Int, $skip: Int) {\n    allUsers(first: $first, skip: $skip) {\n      id\n      name\n      Organization {\n        name\n        id\n      }\n    }\n  }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery AllDeviceTypesQuery($first: Int, $skip: Int) {\n  allDeviceTypes(first: $first, skip: $skip) {\n    id\n    value\n    label\n  }\n}'], ['\nquery AllDeviceTypesQuery($first: Int, $skip: Int) {\n  allDeviceTypes(first: $first, skip: $skip) {\n    id\n    value\n    label\n  }\n}']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery AllCropTypesQuery($first: Int, $skip: Int) {\n  allCropTypes(first: $first, skip: $skip) {\n    id\n    value\n    label\n  }\n}'], ['\nquery AllCropTypesQuery($first: Int, $skip: Int) {\n  allCropTypes(first: $first, skip: $skip) {\n    id\n    value\n    label\n  }\n}']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query AllOrganizationsQuery($hash: String) {\n    allOrganizations(where: { hash: $hash}) {\n      id\n      name\n      hash\n    }\n  }'], ['\n  query AllOrganizationsQuery($hash: String) {\n    allOrganizations(where: { hash: $hash}) {\n      id\n      name\n      hash\n    }\n  }']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation signin($identity: String, $secret: String) {\n    authenticate: authenticateUserWithPassword(email: $identity, password: $secret) {\n      item {\n        id\n        __typename\n      }\n      token\n      __typename\n    }\n  }'], ['\n  mutation signin($identity: String, $secret: String) {\n    authenticate: authenticateUserWithPassword(email: $identity, password: $secret) {\n      item {\n        id\n        __typename\n      }\n      token\n      __typename\n    }\n  }']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createOrganizationMutation($name: String, $hash: String) {\n    createOrganization(\n      data: {\n        name: $name,\n        hash: $hash\n      }\n    ) {\n      id,\n      name\n    }\n  }\n'], ['\n  mutation createOrganizationMutation($name: String, $hash: String) {\n    createOrganization(\n      data: {\n        name: $name,\n        hash: $hash\n      }\n    ) {\n      id,\n      name\n    }\n  }\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateOrganizationMutation($orgId: ID!, $userId: ID!) {\n    updateOrganization (\n      id: $orgId,\n      data: {\n        User: {\n          disconnect: {\n            id: $userId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation updateOrganizationMutation($orgId: ID!, $userId: ID!) {\n    updateOrganization (\n      id: $orgId,\n      data: {\n        User: {\n          disconnect: {\n            id: $userId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateUserMutation($userId: ID!, $orgId: ID!) {\n    updateUser (\n      id: $userId,\n      data: {\n        Organization: {\n          disconnect: {\n            id: $orgId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation updateUserMutation($userId: ID!, $orgId: ID!) {\n    updateUser (\n      id: $userId,\n      data: {\n        Organization: {\n          disconnect: {\n            id: $orgId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation CreateDeviceMutation($deviceTypeId: ID!, $name: String!, $cropTypesIds:[CropTypeWhereUniqueInput], $area: Float $pumpFlow: Float, $length: Int, $orgId: ID!, $latitude: Float, $longitude: Float, $crop: String) {\n    createDevice(\n      data: {\n        name: $name,\n        pumpFlow: $pumpFlow,\n        length: $length,\n        area: $area,\n        DeviceType: {\n          connect: {\n          id: $deviceTypeId\n          }\n        },\n        Crops : {\n          create: {\n            name: $crop,\n            CropType: {\n              disconnectAll: true,\n              connect: $cropTypesIds\n            }\n          }\n        },\n        Location : {\n          create: {\n            latitude: $latitude,\n            longitude: $longitude\n          }\n        },\n        Organization: {\n          connect: {\n            id: $orgId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation CreateDeviceMutation($deviceTypeId: ID!, $name: String!, $cropTypesIds:[CropTypeWhereUniqueInput], $area: Float $pumpFlow: Float, $length: Int, $orgId: ID!, $latitude: Float, $longitude: Float, $crop: String) {\n    createDevice(\n      data: {\n        name: $name,\n        pumpFlow: $pumpFlow,\n        length: $length,\n        area: $area,\n        DeviceType: {\n          connect: {\n          id: $deviceTypeId\n          }\n        },\n        Crops : {\n          create: {\n            name: $crop,\n            CropType: {\n              disconnectAll: true,\n              connect: $cropTypesIds\n            }\n          }\n        },\n        Location : {\n          create: {\n            latitude: $latitude,\n            longitude: $longitude\n          }\n        },\n        Organization: {\n          connect: {\n            id: $orgId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation CreateUserMutation($name: String!, $email: String!, $password: String!, $phone: String!) {\n    createUser(\n      data: {\n        name: $name,\n        email: $email,\n        password: $password,\n        phone: $phone\n      }\n    ) {\n      id\n    }\n\n    authenticate: authenticateUserWithPassword(email: $email, password: $password) {\n      item {\n        id\n        __typename\n      }\n      token\n      __typename\n    }\n  }\n'], ['\n  mutation CreateUserMutation($name: String!, $email: String!, $password: String!, $phone: String!) {\n    createUser(\n      data: {\n        name: $name,\n        email: $email,\n        password: $password,\n        phone: $phone\n      }\n    ) {\n      id\n    }\n\n    authenticate: authenticateUserWithPassword(email: $email, password: $password) {\n      item {\n        id\n        __typename\n      }\n      token\n      __typename\n    }\n  }\n']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateOrganizationMutation($id: ID!, $name: String, $hash: String) {\n    updateOrganization (\n      id: $id,\n      data: {\n        name: $name,\n        hash: $hash\n      }\n    ) {\n      id\n      name\n      hash\n    }\n  }\n'], ['\n  mutation updateOrganizationMutation($id: ID!, $name: String, $hash: String) {\n    updateOrganization (\n      id: $id,\n      data: {\n        name: $name,\n        hash: $hash\n      }\n    ) {\n      id\n      name\n      hash\n    }\n  }\n']),
    _templateObject12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query UserQuery($id: ID!) {\n    User (\n      where: {id: $id}\n    ) {\n      id\n      name\n      email\n      phone\n      Role {\n        id\n        value\n        label\n      }\n      Organization {\n        id\n        name\n        hash\n        User {\n          id,\n          name\n        }\n        Admin {\n          id,\n          name\n        }\n        Device {\n          id,\n          name,\n          Event{\n            id,\n            name,\n            State {\n              id\n              value\n              label\n            }\n          },\n          Crops {\n            id,\n            name\n          }\n        }\n      }\n      isAdmin\n    }\n  }\n'], ['\n  query UserQuery($id: ID!) {\n    User (\n      where: {id: $id}\n    ) {\n      id\n      name\n      email\n      phone\n      Role {\n        id\n        value\n        label\n      }\n      Organization {\n        id\n        name\n        hash\n        User {\n          id,\n          name\n        }\n        Admin {\n          id,\n          name\n        }\n        Device {\n          id,\n          name,\n          Event{\n            id,\n            name,\n            State {\n              id\n              value\n              label\n            }\n          },\n          Crops {\n            id,\n            name\n          }\n        }\n      }\n      isAdmin\n    }\n  }\n']),
    _templateObject13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query DemoOrgQuery {\n    Organization (\n      where: {id: 999}\n    ){\n      id\n      name\n      Device {\n        id,\n        name,\n        Event{\n          id,\n          name,\n          State {\n            id\n          }\n        },\n        Crops {\n          id,\n          name\n        }\n      }\n    }\n  }\n'], ['\n  query DemoOrgQuery {\n    Organization (\n      where: {id: 999}\n    ){\n      id\n      name\n      Device {\n        id,\n        name,\n        Event{\n          id,\n          name,\n          State {\n            id\n          }\n        },\n        Crops {\n          id,\n          name\n        }\n      }\n    }\n  }\n']),
    _templateObject14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query DeviceQuery($id: ID!) {\n    Device (\n      where: {id: $id}\n    ) {\n        id\n        name\n        area\n        Organization{\n          id\n          name\n        }\n        Crops{\n          id\n          name\n        }\n        Location {\n          id\n          latitude\n          longitude\n        }\n        Event {\n          id\n          dateTime\n          sheet\n          Location {\n            id,\n            latitude,\n            longitude\n          }\n          angle\n          pressure\n          direction\n          FailType {\n            id\n            value\n            label\n          }\n          ProcessedState {\n            id\n          }\n          State {\n            id\n            value\n            label\n          }\n        }\n        DeviceType {\n          id\n          value\n          label\n        }\n        pumpFlow\n        length\n    }\n  }\n'], ['\n  query DeviceQuery($id: ID!) {\n    Device (\n      where: {id: $id}\n    ) {\n        id\n        name\n        area\n        Organization{\n          id\n          name\n        }\n        Crops{\n          id\n          name\n        }\n        Location {\n          id\n          latitude\n          longitude\n        }\n        Event {\n          id\n          dateTime\n          sheet\n          Location {\n            id,\n            latitude,\n            longitude\n          }\n          angle\n          pressure\n          direction\n          FailType {\n            id\n            value\n            label\n          }\n          ProcessedState {\n            id\n          }\n          State {\n            id\n            value\n            label\n          }\n        }\n        DeviceType {\n          id\n          value\n          label\n        }\n        pumpFlow\n        length\n    }\n  }\n']),
    _templateObject15 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query OrganizationQuery($id: ID!) {\n    Organization (\n      where: {id: $id}\n    ) {\n        Device {\n          id\n        }\n    }\n  }\n'], ['\n  query OrganizationQuery($id: ID!) {\n    Organization (\n      where: {id: $id}\n    ) {\n        Device {\n          id\n        }\n    }\n  }\n']),
    _templateObject16 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query AllDevicesQuery($first: Int, $skip: Int, $organizationIds: [Int]) {\n    allDevices(first: $first, skip: $skip, where: {AND:[{Event: {State: {value: "', '"}}}, {Organization: {id_in: $organizationIds}}]}) {\n      id\n      name\n      DeviceType {\n        id\n        value\n        label\n      }\n      Event {\n        id\n        FailType {\n          id\n          value\n          label\n        }\n        State {\n          id\n          value\n          label\n        }\n      }\n      Crops {\n        id\n        name\n      }\n    }\n  }'], ['\n  query AllDevicesQuery($first: Int, $skip: Int, $organizationIds: [Int]) {\n    allDevices(first: $first, skip: $skip, where: {AND:[{Event: {State: {value: "', '"}}}, {Organization: {id_in: $organizationIds}}]}) {\n      id\n      name\n      DeviceType {\n        id\n        value\n        label\n      }\n      Event {\n        id\n        FailType {\n          id\n          value\n          label\n        }\n        State {\n          id\n          value\n          label\n        }\n      }\n      Crops {\n        id\n        name\n      }\n    }\n  }']),
    _templateObject17 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query AllEventsQuery($first: Int, $skip: Int, $datetime: DateTime, $organizationIds: [Int]) {\n    allEvents(first: $first, skip: $skip, where: {AND:[{dateTime_gte: $datetime}, {Device: {Organization: {id_in: $organizationIds}}}]}) {\n      id\n      dateTime\n      name\n      note\n      sheet\n      angle\n      pressure\n      FailType {\n        id\n        value\n        label\n      }\n      State {\n        id\n        value\n        label\n      }\n      Device {\n        id\n        name\n        DeviceType {\n          id\n          value\n          label\n        }\n      }\n    }\n  }\n'], ['\n  query AllEventsQuery($first: Int, $skip: Int, $datetime: DateTime, $organizationIds: [Int]) {\n    allEvents(first: $first, skip: $skip, where: {AND:[{dateTime_gte: $datetime}, {Device: {Organization: {id_in: $organizationIds}}}]}) {\n      id\n      dateTime\n      name\n      note\n      sheet\n      angle\n      pressure\n      FailType {\n        id\n        value\n        label\n      }\n      State {\n        id\n        value\n        label\n      }\n      Device {\n        id\n        name\n        DeviceType {\n          id\n          value\n          label\n        }\n      }\n    }\n  }\n']),
    _templateObject18 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateUserMutation($id: ID!, $name: String, $email: String, $phone: String) {\n    updateUser (\n      id: $id,\n      data: {\n        name: $name\n        email: $email\n        phone: $phone\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation updateUserMutation($id: ID!, $name: String, $email: String, $phone: String) {\n    updateUser (\n      id: $id,\n      data: {\n        name: $name\n        email: $email\n        phone: $phone\n      }\n    ) {\n      id\n    }\n  }\n']),
    _templateObject19 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateUserMutation($userId: ID!, $orgId: ID!) {\n    updateUser (\n      id: $userId\n      data: {\n        Organization: {\n          connect: {\n            id: $orgId\n          }\n        }\n      }\n    ) {\n      id\n      Organization {\n        id\n        name\n        User {\n          id,\n          name\n        }\n      }\n    }\n\n    updateOrganization (\n      id: $orgId\n      data: {\n        User: {\n          connect: {\n            id: $userId\n          }\n        }\n      }\n    ) {\n      id\n      User {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  mutation updateUserMutation($userId: ID!, $orgId: ID!) {\n    updateUser (\n      id: $userId\n      data: {\n        Organization: {\n          connect: {\n            id: $orgId\n          }\n        }\n      }\n    ) {\n      id\n      Organization {\n        id\n        name\n        User {\n          id,\n          name\n        }\n      }\n    }\n\n    updateOrganization (\n      id: $orgId\n      data: {\n        User: {\n          connect: {\n            id: $userId\n          }\n        }\n      }\n    ) {\n      id\n      User {\n        id\n        name\n      }\n    }\n  }\n']),
    _templateObject20 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateUserMutation($userId: ID!, $roleId: ID!) {\n    updateUser (\n      id: $userId\n      data: {\n        Role: {\n          connect: {\n            id: $roleId\n          }\n        }\n      }\n    ) {\n      id\n      Organization {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  mutation updateUserMutation($userId: ID!, $roleId: ID!) {\n    updateUser (\n      id: $userId\n      data: {\n        Role: {\n          connect: {\n            id: $roleId\n          }\n        }\n      }\n    ) {\n      id\n      Organization {\n        id\n        name\n      }\n    }\n  }\n']),
    _templateObject21 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateOrganizationMutation($deviceId: ID!, $orgId: ID!) {\n    updateOrganization (\n      id: $orgId\n      data: {\n        Device: {\n          connect: {\n            id: $deviceId\n          }\n        }\n      }\n    ) {\n      id\n      Device {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  mutation updateOrganizationMutation($deviceId: ID!, $orgId: ID!) {\n    updateOrganization (\n      id: $orgId\n      data: {\n        Device: {\n          connect: {\n            id: $deviceId\n          }\n        }\n      }\n    ) {\n      id\n      Device {\n        id\n        name\n      }\n    }\n  }\n']),
    _templateObject22 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateOrganizationMutation($orgId: ID!, $userId: ID!) {\n    updateOrganization (\n      id: $orgId\n      data: {\n        Admin: {\n          disconnectAll: true,\n          connect: {\n            id: $userId\n          }\n        }\n      }\n    ) {\n      id\n      Admin {\n        id\n        name\n      }\n    }\n  }\n'], ['\n  mutation updateOrganizationMutation($orgId: ID!, $userId: ID!) {\n    updateOrganization (\n      id: $orgId\n      data: {\n        Admin: {\n          disconnectAll: true,\n          connect: {\n            id: $userId\n          }\n        }\n      }\n    ) {\n      id\n      Admin {\n        id\n        name\n      }\n    }\n  }\n']),
    _templateObject23 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query AllRolesQuery($first: Int, $skip: Int) {\n    allRoles(first: $first, skip: $skip) {\n      id\n      value\n      label\n    }\n  }\n'], ['\n  query AllRolesQuery($first: Int, $skip: Int) {\n    allRoles(first: $first, skip: $skip) {\n      id\n      value\n      label\n    }\n  }\n']),
    _templateObject24 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query EventQuery($id: Int) {\n    allEvents (\n      where: {Device: { id: $id}}\n    ) {\n        id\n        dateTime\n        name\n        note\n        sheet\n        angle\n        pressure\n        direction\n        FailType {\n          id\n          value\n          label\n        }\n        State {\n          id\n          value\n          label\n        }\n        Device {\n          id\n          name\n        }\n    }\n  }\n'], ['\n  query EventQuery($id: Int) {\n    allEvents (\n      where: {Device: { id: $id}}\n    ) {\n        id\n        dateTime\n        name\n        note\n        sheet\n        angle\n        pressure\n        direction\n        FailType {\n          id\n          value\n          label\n        }\n        State {\n          id\n          value\n          label\n        }\n        Device {\n          id\n          name\n        }\n    }\n  }\n']),
    _templateObject25 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query AllStatesQuery($first: Int, $skip: Int) {\n    allStates(first: $first, skip: $skip) {\n      id\n      value\n      label\n    }\n  }\n'], ['\n  query AllStatesQuery($first: Int, $skip: Int) {\n    allStates(first: $first, skip: $skip) {\n      id\n      value\n      label\n    }\n  }\n']),
    _templateObject26 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  query AllFailTypesQuery($first: Int, $skip: Int) {\n    allFailTypes(first: $first, skip: $skip) {\n      id\n      value\n      label\n    }\n  }\n'], ['\n  query AllFailTypesQuery($first: Int, $skip: Int) {\n    allFailTypes(first: $first, skip: $skip) {\n      id\n      value\n      label\n    }\n  }\n']),
    _templateObject27 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation CreateEventMutation($dateTime: DateTime!, $direction: String, $name: String, $note: String, $sheet: Float, $angle: Float, $pressure: Float, $stateId: ID!, $deviceId: ID!, $latitude: Float, $longitude: Float) {\n    createEvent(\n      data: {\n        dateTime: $dateTime,\n        name: $name,\n        note: $note,\n        sheet: $sheet,\n        angle: $angle,\n        pressure: $pressure,\n        direction: $direction,\n        Location : {\n          create: {\n            latitude: $latitude,\n            longitude: $longitude\n          }\n        },\n        State: {\n          connect: {\n            id: $stateId\n          }\n        },\n        Device: {\n          connect: {\n            id: $deviceId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation CreateEventMutation($dateTime: DateTime!, $direction: String, $name: String, $note: String, $sheet: Float, $angle: Float, $pressure: Float, $stateId: ID!, $deviceId: ID!, $latitude: Float, $longitude: Float) {\n    createEvent(\n      data: {\n        dateTime: $dateTime,\n        name: $name,\n        note: $note,\n        sheet: $sheet,\n        angle: $angle,\n        pressure: $pressure,\n        direction: $direction,\n        Location : {\n          create: {\n            latitude: $latitude,\n            longitude: $longitude\n          }\n        },\n        State: {\n          connect: {\n            id: $stateId\n          }\n        },\n        Device: {\n          connect: {\n            id: $deviceId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n']),
    _templateObject28 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation CreateEventMutation($dateTime: DateTime!, $name: String, $note: String, $deviceId: ID!) {\n    createEvent(\n      data: {\n        dateTime: $dateTime,\n        name: $name,\n        note: $note,\n        Device: {\n          connect: {\n            id: $deviceId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation CreateEventMutation($dateTime: DateTime!, $name: String, $note: String, $deviceId: ID!) {\n    createEvent(\n      data: {\n        dateTime: $dateTime,\n        name: $name,\n        note: $note,\n        Device: {\n          connect: {\n            id: $deviceId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n']),
    _templateObject29 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateEventMutation($id: ID!, $failTypeId: ID!) {\n    updateEvent (\n      id: $id,\n      data: {\n        FailType: {\n          connect: {\n            id: $failTypeId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation updateEventMutation($id: ID!, $failTypeId: ID!) {\n    updateEvent (\n      id: $id,\n      data: {\n        FailType: {\n          connect: {\n            id: $failTypeId\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n']),
    _templateObject30 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateDeviceMutation($id: ID!, $deviceId: ID!) {\n    updateDevice (\n      id: $deviceId,\n      data: {\n        Event: {\n          connect: {\n            id: $id\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n'], ['\n  mutation updateDeviceMutation($id: ID!, $deviceId: ID!) {\n    updateDevice (\n      id: $deviceId,\n      data: {\n        Event: {\n          connect: {\n            id: $id\n          }\n        }\n      }\n    ) {\n      id\n    }\n  }\n']);




var ALL_USERS_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject);

var ALL_DEVICE_TYPES_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject2);

var ALL_CROP_TYPES_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject3);

var HASH_ORGANIZATION_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject4);

var SIGNIN_USER_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject5);

var CREATE_ORGANIZATION_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject6);

var DISCONNECT_USER_FROM_ORGANIZATION_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject7);

var DISCONNECT_ORGANIZATION_FROM_USER_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject8);

var CREATE_DEVICE_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject9);

var CREATE_USER_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject10);

var UPDATE_ORGANIZATION_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject11);

var USER_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject12);

var DEMO_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject13);

var DEVICE_DETAIL_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject14);

var ORGANIZATION_DEVICES_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject15);

var DEVICES_FAILING_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject16, __WEBPACK_IMPORTED_MODULE_2__constants_constants__["STATES"].FAILURE);

var ALL_DEVICES_TIMELINE_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject17);

var UPDATE_USER_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject18);

var UPDATE_USER_ORGANIZATION_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject19);

var UPDATE_USER_ROLE_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject20);

var UPDATE_DEVICE_ORGANIZATION_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject21);

var UPDATE_ORGANIZATION__ADMIN_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject22);

var ALL_ROLES_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject23);

var DEVICE_TIMELINE_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject24);

var ALL_STATES_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject25);

var ALL_FAILTYPES_QUERY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject26);

var CREATE_EVENT_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject27);

var CREATE_IRRIGATION_ORDER_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject28);

var UPDATE_FAILTYPE_EVENT_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject29);

var UPDATE_DEVICE_EVENT_MUTATION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject30);

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_apollo__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_check_connection__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_config__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_filters__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_firebase__ = __webpack_require__(136);
var App = function App() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 245));
};











var Vue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register__["a" /* VueRegister */])();
var apolloProvider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_apollo__["a" /* Apollo */])();
/* eslint-disable no-new */

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__constants_filters__["a" /* default */])(Vue);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__constants_config__["a" /* default */])(Vue);

new Vue({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */],
  apolloProvider: apolloProvider,
  store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */],
  template: '<App/>',
  components: { App: App },
  data: {
    config: __WEBPACK_IMPORTED_MODULE_5__constants_config__["a" /* default */],
    filters: __WEBPACK_IMPORTED_MODULE_6__constants_filters__["a" /* default */]
  },
  created: function created() {}
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  var token = localStorage.getItem('auth_token');
  var routeInit = ['/', '/signup', '/signup2', '/signin'].includes(to.fullPath);
  if (routeInit) {
    if (token) {
      next('/equipments');
    } else {
      next();
    }
  } else if (token) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_apollo__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_graphql__ = __webpack_require__(139);


var apollo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_apollo__["a" /* Apollo */])();


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    isUploading: false,
    events: {}
  },
  mutations: {
    addEvent: function addEvent(state, payload) {
      state.events[payload.key] = payload.value;
    },
    removeEvent: function removeEvent(state, key) {
      delete state.events[key];
    },
    updateIsUploading: function updateIsUploading(state, value) {
      state.isUploading = value;
    }
  },
  actions: {
    addEvent: function addEvent(_ref, payload) {
      var commit = _ref.commit;

      commit('addEvent', payload);
    },
    removeEvent: function removeEvent(_ref2, key) {
      var commit = _ref2.commit;

      commit('removeEvent', key);
    },
    uploadStoreEvents: function uploadStoreEvents(context) {
      context.commit('updateIsUploading', true);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(context.getters.events).length) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(context.getters.events).forEach(function (event) {
          if (event[1].note && event[1].note.length) {
            context.dispatch('uploadIrrigationOrder', {
              variables: event[1],
              comesFromStore: true,
              key: event[0]
            });
          } else if (event[1].auxObj) {
            context.dispatch('uploadCommonEvent', {
              variables: event[1].variables,
              auxObj: event[1].auxObj,
              comesFromStore: true,
              key: event[0]
            });
          }
        });
      }
      context.commit('updateIsUploading', false);
    },
    uploadIrrigationOrder: function uploadIrrigationOrder(context, value) {
      apollo.defaultClient.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__constants_graphql__["a" /* CREATE_IRRIGATION_ORDER_MUTATION */],
        variables: value.variables
      }).then(function () {
        if (value.comesFromStore) {
          context.commit('removeEvent', value.key);
        }
      }).catch(function () {
        if (!value.comesFromStore) {
          context.commit('addEvent', {
            key: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(context.getters.events).length,
            value: value.variables
          });
        }
      });
    },
    uploadCommonEvent: function uploadCommonEvent(context, value) {
      apollo.defaultClient.mutate({
        mutation: __WEBPACK_IMPORTED_MODULE_2__constants_graphql__["b" /* CREATE_EVENT_MUTATION */],
        variables: value.variables
      }).then(function (result) {
        var id = result.data.createEvent.id;
        if (value.auxObj.selectedFailureType !== '') {
          apollo.defaultClient.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_2__constants_graphql__["c" /* UPDATE_FAILTYPE_EVENT_MUTATION */],
            variables: {
              id: id,
              failTypeId: value.auxObj.selectedFailureType
            }
          }).then(function () {}).catch(function () {});
        }
        if (!value.auxObj.lastEventDate || value.auxObj.eventDate >= value.auxObj.lastEventDate) {
          apollo.defaultClient.mutate({
            mutation: __WEBPACK_IMPORTED_MODULE_2__constants_graphql__["d" /* UPDATE_DEVICE_EVENT_MUTATION */],
            variables: {
              id: id,
              deviceId: parseInt(value.auxObj.deviceId)
            }
          }).then(function () {
            if (value.comesFromStore) {
              context.commit('removeEvent', value.key);
            }
          }).catch(function () {});
        }
      }).catch(function () {
        if (!value.comesFromStore) {
          context.commit('addEvent', {
            key: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(context.getters.events).length,
            value: {
              variables: value.variables,
              auxObj: value.auxObj
            }
          });
        }
      });
    }
  },
  getters: {
    events: function events(state) {
      return state.events;
    },
    event: function event(_ref3, key) {
      var state = _ref3.state;

      return state.events[key];
    },
    isUploading: function isUploading(state) {
      return state.isUploading;
    }
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    showStepSignup: false,
    showStepOrganization: false,
    step: 1,
    loading: false,
    error: null,
    isOnline: true,
    window: {
      width: 0,
      height: 0
    }
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setStep: function setStep(state, payload) {
      state.step = payload;
    },
    setShowStepOrganization: function setShowStepOrganization(state, payload) {
      state.showStepOrganization = payload;
    },
    setShowStepSignup: function setShowStepSignup(state, payload) {
      state.showStepSignup = payload;
    },
    setIsOnline: function setIsOnline(state, payload) {
      state.isOnline = payload;
    },
    setWidth: function setWidth(state, payload) {
      state.window.width = payload;
    },
    setHeight: function setHeight(state, payload) {
      state.window.height = payload;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },
    setError: function setError(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setError', payload);
    },
    setStep: function setStep(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setStep', payload);
    },
    setShowStepOrganization: function setShowStepOrganization(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setShowStepOrganization', payload);
    },
    setShowStepSignup: function setShowStepSignup(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setShowStepSignup', payload);
    },
    setIsOnline: function setIsOnline(_ref6, payload) {
      var commit = _ref6.commit;

      commit('setIsOnline', payload);
    },
    setWidth: function setWidth(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setWidth', payload);
    },
    setHeight: function setHeight(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setHeight', payload);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    },
    step: function step(state) {
      return state.step;
    },
    showStepOrganization: function showStepOrganization(state) {
      return state.showStepOrganization;
    },
    showStepSignup: function showStepSignup(state) {
      return state.showStepSignup;
    },
    isOnline: function isOnline(state) {
      return state.isOnline;
    },
    width: function width(state) {
      return state.window.width;
    },
    height: function height(state) {
      return state.window.height;
    }
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    signUserIn: function signUserIn(_ref, payload) {
      var commit = _ref.commit;

      commit('setUser', payload);
    },
    autoSignIn: function autoSignIn(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      });
    },
    resetPasswordWithEmail: function resetPasswordWithEmail(_ref3, payload) {
      var commit = _ref3.commit;

      // const { email } = payload
      commit('setLoading', true);
      // Petition a graphql, concatenada con el siguiente then..
      // .then(
      //   () => {
      //     commit('setLoading', false)
      //     console.log('Email Sent')
      //   }
      // )
      // .catch(
      //   error => {
      //     commit('setLoading', false)
      //     commit('setError', error)
      //     console.log(error)
      //   }
      // )
    },
    logout: function logout(_ref4) {
      var commit = _ref4.commit;

      // Petition a graphql, concatenada con el siguiente then..
      commit('setUser', null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    }
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(258)));

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(260)));

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(261)));

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(266)));

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__version__);
/* unused harmony reexport version */
/* unused harmony reexport versionInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__graphql__);
/* unused harmony reexport graphql */
/* unused harmony reexport graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__type__);
/* unused harmony reexport GraphQLSchema */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport TypeKind */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* unused harmony reexport isSchema */
/* unused harmony reexport isDirective */
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport isRequiredArgument */
/* unused harmony reexport isRequiredInputField */
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport assertSchema */
/* unused harmony reexport assertDirective */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__language__);
/* unused harmony reexport Source */
/* unused harmony reexport getLocation */
/* unused harmony reexport printLocation */
/* unused harmony reexport printSourceLocation */
/* unused harmony reexport createLexer */
/* unused harmony reexport TokenKind */
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3__language__, "parse")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__language__["parse"]; });
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* unused harmony reexport print */
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport visitWithTypeInfo */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport BREAK */
/* unused harmony reexport Kind */
/* unused harmony reexport DirectiveLocation */
/* unused harmony reexport isDefinitionNode */
/* unused harmony reexport isExecutableDefinitionNode */
/* unused harmony reexport isSelectionNode */
/* unused harmony reexport isValueNode */
/* unused harmony reexport isTypeNode */
/* unused harmony reexport isTypeSystemDefinitionNode */
/* unused harmony reexport isTypeDefinitionNode */
/* unused harmony reexport isTypeSystemExtensionNode */
/* unused harmony reexport isTypeExtensionNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__execution__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__execution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__execution__);
/* unused harmony reexport execute */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport defaultTypeResolver */
/* unused harmony reexport responsePathAsArray */
/* unused harmony reexport getDirectiveValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscription__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__subscription__);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__validation__);
/* unused harmony reexport validate */
/* unused harmony reexport ValidationContext */
/* unused harmony reexport specifiedRules */
/* unused harmony reexport ExecutableDefinitionsRule */
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* unused harmony reexport KnownArgumentNamesRule */
/* unused harmony reexport KnownDirectivesRule */
/* unused harmony reexport KnownFragmentNamesRule */
/* unused harmony reexport KnownTypeNamesRule */
/* unused harmony reexport LoneAnonymousOperationRule */
/* unused harmony reexport NoFragmentCyclesRule */
/* unused harmony reexport NoUndefinedVariablesRule */
/* unused harmony reexport NoUnusedFragmentsRule */
/* unused harmony reexport NoUnusedVariablesRule */
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* unused harmony reexport ProvidedRequiredArgumentsRule */
/* unused harmony reexport ScalarLeafsRule */
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* unused harmony reexport UniqueArgumentNamesRule */
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* unused harmony reexport UniqueFragmentNamesRule */
/* unused harmony reexport UniqueInputFieldNamesRule */
/* unused harmony reexport UniqueOperationNamesRule */
/* unused harmony reexport UniqueVariableNamesRule */
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* unused harmony reexport VariablesAreInputTypesRule */
/* unused harmony reexport VariablesInAllowedPositionRule */
/* unused harmony reexport LoneSchemaDefinitionRule */
/* unused harmony reexport UniqueOperationTypesRule */
/* unused harmony reexport UniqueTypeNamesRule */
/* unused harmony reexport UniqueEnumValueNamesRule */
/* unused harmony reexport UniqueFieldDefinitionNamesRule */
/* unused harmony reexport UniqueDirectiveNamesRule */
/* unused harmony reexport PossibleTypeExtensionsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__error__);
/* unused harmony reexport GraphQLError */
/* unused harmony reexport syntaxError */
/* unused harmony reexport locatedError */
/* unused harmony reexport printError */
/* unused harmony reexport formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__utilities__);
/* unused harmony reexport getIntrospectionQuery */
/* unused harmony reexport introspectionQuery */
/* unused harmony reexport getOperationAST */
/* unused harmony reexport getOperationRootType */
/* unused harmony reexport introspectionFromSchema */
/* unused harmony reexport buildClientSchema */
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* unused harmony reexport getDescription */
/* unused harmony reexport extendSchema */
/* unused harmony reexport lexicographicSortSchema */
/* unused harmony reexport printSchema */
/* unused harmony reexport printType */
/* unused harmony reexport printIntrospectionSchema */
/* unused harmony reexport typeFromAST */
/* unused harmony reexport valueFromAST */
/* unused harmony reexport valueFromASTUntyped */
/* unused harmony reexport astFromValue */
/* unused harmony reexport TypeInfo */
/* unused harmony reexport coerceInputValue */
/* unused harmony reexport coerceValue */
/* unused harmony reexport isValidJSValue */
/* unused harmony reexport isValidLiteralValue */
/* unused harmony reexport concatAST */
/* unused harmony reexport separateOperations */
/* unused harmony reexport stripIgnoredCharacters */
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* unused harmony reexport findDeprecatedUsages */
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */
// The GraphQL.js version info.
 // The primary entry point into fulfilling a GraphQL request.

 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.


// Validate GraphQL documents.

// Create, format, and print GraphQL errors.

// Utilities for operating on GraphQL type schema and parsed sources.



/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(254),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(251),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 251:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', _vm._g(_vm._b({
    ref: "input"
  }, 'input', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

module.exports = {"_from":"weekstart@^1.0.1","_id":"weekstart@1.1.0","_inBundle":false,"_integrity":"sha512-ZO3I7c7J9nwGN1PZKZeBYAsuwWEsCOZi5T68cQoVNYrzrpp5Br0Bgi0OF4l8kH/Ez7nKfxa5mSsXjsgris3+qg==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"weekstart@^1.0.1","name":"weekstart","escapedName":"weekstart","rawSpec":"^1.0.1","saveSpec":null,"fetchSpec":"^1.0.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.1.0.tgz","_shasum":"af642eb10dc24b1af9d4dcc0415056edc087b897","_spec":"weekstart@^1.0.1","_where":"/workspace","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"bundleDependencies":false,"deprecated":false,"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"^7.13.10","eslint":"^7.22.0","eslint-config-guard":"^2.0.1","ink-docstrap":"1.3.2","jest":"^26.6.3","jsdoc":"^3.6.6","jsdoc-file":"^1.0.1","microbundle":"0.4.4","version-bump-prompt":"^6.1.0"},"files":["dist","full.js","full.d.ts","index.d.ts","src","History.md"],"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.js","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.1.0"}

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$iterator", function() { return $$iterator; });
/* harmony export (immutable) */ __webpack_exports__["isIterable"] = isIterable;
/* harmony export (immutable) */ __webpack_exports__["isArrayLike"] = isArrayLike;
/* harmony export (immutable) */ __webpack_exports__["isCollection"] = isCollection;
/* harmony export (immutable) */ __webpack_exports__["getIterator"] = getIterator;
/* harmony export (immutable) */ __webpack_exports__["getIteratorMethod"] = getIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createIterator"] = createIterator;
/* harmony export (immutable) */ __webpack_exports__["forEach"] = forEach;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$asyncIterator", function() { return $$asyncIterator; });
/* harmony export (immutable) */ __webpack_exports__["isAsyncIterable"] = isAsyncIterable;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIterator"] = getAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIteratorMethod"] = getAsyncIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createAsyncIterator"] = createAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["forAwaitEach"] = forAwaitEach;
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */

/**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */

/**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */

// In ES2015 environments, Symbol exists
var SYMBOL /*: any */ = typeof Symbol === 'function' ? Symbol : void 0

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var SYMBOL_ITERATOR = SYMBOL && SYMBOL.iterator

/**
 * A property name to be used as the name of an Iterable's method responsible
 * for producing an Iterator, referred to as `@@iterator`. Typically represents
 * the value `Symbol.iterator` but falls back to the string `"@@iterator"` when
 * `Symbol.iterator` is not defined.
 *
 * Use `$$iterator` for defining new Iterables instead of `Symbol.iterator`,
 * but do not use it for accessing existing Iterables, instead use
 * {@link getIterator} or {@link isIterable}.
 *
 * @example
 *
 * var $$iterator = require('iterall').$$iterator
 *
 * function Counter (to) {
 *   this.to = to
 * }
 *
 * Counter.prototype[$$iterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       if (this.num >= this.to) {
 *         return { value: undefined, done: true }
 *       }
 *       return { value: this.num++, done: false }
 *     }
 *   }
 * }
 *
 * var counter = new Counter(3)
 * for (var number of counter) {
 *   console.log(number) // 0 ... 1 ... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$iterator: '@@iterator'; */
var $$iterator = SYMBOL_ITERATOR || '@@iterator'

/**
 * Returns true if the provided object implements the Iterator protocol via
 * either implementing a `Symbol.iterator` or `"@@iterator"` method.
 *
 * @example
 *
 * var isIterable = require('iterall').isIterable
 * isIterable([ 1, 2, 3 ]) // true
 * isIterable('ABC') // true
 * isIterable({ length: 1, 0: 'Alpha' }) // false
 * isIterable({ key: 'value' }) // false
 * isIterable(new Map()) // true
 *
 * @param obj
 *   A value which might implement the Iterable protocol.
 * @return {boolean} true if Iterable.
 */
/*:: declare export function isIterable(obj: any): boolean; */
function isIterable(obj) {
  return !!getIteratorMethod(obj)
}

/**
 * Returns true if the provided object implements the Array-like protocol via
 * defining a positive-integer `length` property.
 *
 * @example
 *
 * var isArrayLike = require('iterall').isArrayLike
 * isArrayLike([ 1, 2, 3 ]) // true
 * isArrayLike('ABC') // true
 * isArrayLike({ length: 1, 0: 'Alpha' }) // true
 * isArrayLike({ key: 'value' }) // false
 * isArrayLike(new Map()) // false
 *
 * @param obj
 *   A value which might implement the Array-like protocol.
 * @return {boolean} true if Array-like.
 */
/*:: declare export function isArrayLike(obj: any): boolean; */
function isArrayLike(obj) {
  var length = obj != null && obj.length
  return typeof length === 'number' && length >= 0 && length % 1 === 0
}

/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and is either Iterable or Array-like.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if an
 * object should be iterated-over. It always excludes string literals and
 * includes Arrays (regardless of if it is Iterable). It also includes other
 * Array-like objects such as NodeList, TypedArray, and Buffer.
 *
 * @example
 *
 * var isCollection = require('iterall').isCollection
 * isCollection([ 1, 2, 3 ]) // true
 * isCollection('ABC') // false
 * isCollection({ length: 1, 0: 'Alpha' }) // true
 * isCollection({ key: 'value' }) // false
 * isCollection(new Map()) // true
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 * if (isCollection(obj)) {
 *   forEach(obj, function (value) {
 *     console.log(value)
 *   })
 * }
 *
 * @param obj
 *   An Object value which might implement the Iterable or Array-like protocols.
 * @return {boolean} true if Iterable or Array-like Object.
 */
/*:: declare export function isCollection(obj: any): boolean; */
function isCollection(obj) {
  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj))
}

/**
 * If the provided object implements the Iterator protocol, its Iterator object
 * is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getIterator = require('iterall').getIterator
 * var iterator = getIterator([ 1, 2, 3 ])
 * iterator.next() // { value: 1, done: false }
 * iterator.next() // { value: 2, done: false }
 * iterator.next() // { value: 3, done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which is the source of an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var getIterator:
  & (<+TValue>(iterable: Iterable<TValue>) => Iterator<TValue>)
  & ((iterable: mixed) => void | Iterator<mixed>); */
function getIterator(iterable) {
  var method = getIteratorMethod(iterable)
  if (method) {
    return method.call(iterable)
  }
}

/**
 * If the provided object implements the Iterator protocol, the method
 * responsible for producing its Iterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getIteratorMethod = require('iterall').getIteratorMethod
 * var myArray = [ 1, 2, 3 ]
 * var method = getIteratorMethod(myArray)
 * if (method) {
 *   var iterator = method.call(myArray)
 * }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which defines an `@@iterator` method.
 * @return {function(): Iterator<T>} `@@iterator` method.
 */
/*:: declare export var getIteratorMethod:
  & (<+TValue>(iterable: Iterable<TValue>) => (() => Iterator<TValue>))
  & ((iterable: mixed) => (void | (() => Iterator<mixed>))); */
function getIteratorMethod(iterable) {
  if (iterable != null) {
    var method =
      (SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR]) || iterable['@@iterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getIterator}, this method returns a new Iterator given an
 * Iterable. However it will also create an Iterator for a non-Iterable
 * Array-like collection, such as Array in a non-ES2015 environment.
 *
 * `createIterator` is complimentary to `forEach`, but allows a "pull"-based
 * iteration as opposed to `forEach`'s "push"-based iteration.
 *
 * `createIterator` produces an Iterator for Array-likes with the same behavior
 * as ArrayIteratorPrototype described in the ECMAScript specification, and
 * does *not* skip over "holes".
 *
 * @example
 *
 * var createIterator = require('iterall').createIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createIterator(myArraylike)
 * iterator.next() // { value: 'Alpha', done: false }
 * iterator.next() // { value: 'Bravo', done: false }
 * iterator.next() // { value: 'Charlie', done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   An Iterable or Array-like object to produce an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var createIterator:
  & (<+TValue>(collection: Iterable<TValue>) => Iterator<TValue>)
  & ((collection: {length: number}) => Iterator<mixed>)
  & ((collection: mixed) => (void | Iterator<mixed>)); */
function createIterator(collection) {
  if (collection != null) {
    var iterator = getIterator(collection)
    if (iterator) {
      return iterator
    }
    if (isArrayLike(collection)) {
      return new ArrayLikeIterator(collection)
    }
  }
}

// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function ArrayLikeIterator(obj) {
  this._o = obj
  this._i = 0
}

// Note: all Iterators are themselves Iterable.
ArrayLikeIterator.prototype[$$iterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
ArrayLikeIterator.prototype.next = function() {
  if (this._o === void 0 || this._i >= this._o.length) {
    this._o = void 0
    return { value: void 0, done: true }
  }
  return { value: this._o[this._i++], done: false }
}

/**
 * Given an object which either implements the Iterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forEach` where you would expect to use a `for ... of` loop in ES6.
 * However `forEach` adheres to the behavior of [Array#forEach][] described in
 * the ECMAScript specification, skipping over "holes" in Array-likes. It will
 * also delegate to a `forEach` method on `collection` if one is defined,
 * ensuring native performance for `Arrays`.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * Note: providing an infinite Iterator to forEach will produce an error.
 *
 * [Array#forEach]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 *
 * forEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES6:
 * for (let value of myIterable) {
 *   console.log(value)
 * }
 *
 * // Any JavaScript environment:
 * forEach(myIterable, function (value) {
 *   console.log(value)
 * })
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   The Iterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forEach:
  & (<+TValue, TCollection: Iterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void)
  & (<TCollection: {length: number}>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void); */
function forEach(collection, callback, thisArg) {
  if (collection != null) {
    if (typeof collection.forEach === 'function') {
      return collection.forEach(callback, thisArg)
    }
    var i = 0
    var iterator = getIterator(collection)
    if (iterator) {
      var step
      while (!(step = iterator.next()).done) {
        callback.call(thisArg, step.value, i++, collection)
        // Infinite Iterators could cause forEach to run forever.
        // After a very large number of iterations, produce an error.
        /* istanbul ignore if */
        if (i > 9999999) {
          throw new TypeError('Near-infinite iteration.')
        }
      }
    } else if (isArrayLike(collection)) {
      for (; i < collection.length; i++) {
        if (collection.hasOwnProperty(i)) {
          callback.call(thisArg, collection[i], i, collection)
        }
      }
    }
  }
}

/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////

/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */

/**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */

// In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = SYMBOL && SYMBOL.asyncIterator

/**
 * A property name to be used as the name of an AsyncIterable's method
 * responsible for producing an Iterator, referred to as `@@asyncIterator`.
 * Typically represents the value `Symbol.asyncIterator` but falls back to the
 * string `"@@asyncIterator"` when `Symbol.asyncIterator` is not defined.
 *
 * Use `$$asyncIterator` for defining new AsyncIterables instead of
 * `Symbol.asyncIterator`, but do not use it for accessing existing Iterables,
 * instead use {@link getAsyncIterator} or {@link isAsyncIterable}.
 *
 * @example
 *
 * var $$asyncIterator = require('iterall').$$asyncIterator
 *
 * function Chirper (to) {
 *   this.to = to
 * }
 *
 * Chirper.prototype[$$asyncIterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       return new Promise(resolve => {
 *         if (this.num >= this.to) {
 *           resolve({ value: undefined, done: true })
 *         } else {
 *           setTimeout(() => {
 *             resolve({ value: this.num++, done: false })
 *           }, 1000)
 *         }
 *       })
 *     }
 *   }
 * }
 *
 * var chirper = new Chirper(3)
 * for await (var number of chirper) {
 *   console.log(number) // 0 ...wait... 1 ...wait... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$asyncIterator: '@@asyncIterator'; */
var $$asyncIterator = SYMBOL_ASYNC_ITERATOR || '@@asyncIterator'

/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
 *
 * @example
 *
 * var isAsyncIterable = require('iterall').isAsyncIterable
 * isAsyncIterable(myStream) // true
 * isAsyncIterable('ABC') // false
 *
 * @param obj
 *   A value which might implement the AsyncIterable protocol.
 * @return {boolean} true if AsyncIterable.
 */
/*:: declare export function isAsyncIterable(obj: any): boolean; */
function isAsyncIterable(obj) {
  return !!getAsyncIteratorMethod(obj)
}

/**
 * If the provided object implements the AsyncIterator protocol, its
 * AsyncIterator object is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getAsyncIterator = require('iterall').getAsyncIterator
 * var asyncIterator = getAsyncIterator(myStream)
 * asyncIterator.next().then(console.log) // { value: 1, done: false }
 * asyncIterator.next().then(console.log) // { value: 2, done: false }
 * asyncIterator.next().then(console.log) // { value: 3, done: false }
 * asyncIterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which is the source of an AsyncIterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var getAsyncIterator:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => AsyncIterator<TValue>)
  & ((asyncIterable: mixed) => (void | AsyncIterator<mixed>)); */
function getAsyncIterator(asyncIterable) {
  var method = getAsyncIteratorMethod(asyncIterable)
  if (method) {
    return method.call(asyncIterable)
  }
}

/**
 * If the provided object implements the AsyncIterator protocol, the method
 * responsible for producing its AsyncIterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getAsyncIteratorMethod = require('iterall').getAsyncIteratorMethod
 * var method = getAsyncIteratorMethod(myStream)
 * if (method) {
 *   var asyncIterator = method.call(myStream)
 * }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which defines an `@@asyncIterator` method.
 * @return {function(): AsyncIterator<T>} `@@asyncIterator` method.
 */
/*:: declare export var getAsyncIteratorMethod:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => (() => AsyncIterator<TValue>))
  & ((asyncIterable: mixed) => (void | (() => AsyncIterator<mixed>))); */
function getAsyncIteratorMethod(asyncIterable) {
  if (asyncIterable != null) {
    var method =
      (SYMBOL_ASYNC_ITERATOR && asyncIterable[SYMBOL_ASYNC_ITERATOR]) ||
      asyncIterable['@@asyncIterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getAsyncIterator}, this method returns a new AsyncIterator
 * given an AsyncIterable. However it will also create an AsyncIterator for a
 * non-async Iterable as well as non-Iterable Array-like collection, such as
 * Array in a pre-ES2015 environment.
 *
 * `createAsyncIterator` is complimentary to `forAwaitEach`, but allows a
 * buffering "pull"-based iteration as opposed to `forAwaitEach`'s
 * "push"-based iteration.
 *
 * `createAsyncIterator` produces an AsyncIterator for non-async Iterables as
 * described in the ECMAScript proposal [Async-from-Sync Iterator Objects](https://tc39.github.io/proposal-async-iteration/#sec-async-from-sync-iterator-objects).
 *
 * > Note: Creating `AsyncIterator`s requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var createAsyncIterator = require('iterall').createAsyncIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createAsyncIterator(myArraylike)
 * iterator.next().then(console.log) // { value: 'Alpha', done: false }
 * iterator.next().then(console.log) // { value: 'Bravo', done: false }
 * iterator.next().then(console.log) // { value: 'Charlie', done: false }
 * iterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<T>|{ length: number }} source
 *   An AsyncIterable, Iterable, or Array-like object to produce an Iterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var createAsyncIterator:
  & (<+TValue>(
      collection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>
    ) => AsyncIterator<TValue>)
  & ((collection: {length: number}) => AsyncIterator<mixed>)
  & ((collection: mixed) => (void | AsyncIterator<mixed>)); */
function createAsyncIterator(source) {
  if (source != null) {
    var asyncIterator = getAsyncIterator(source)
    if (asyncIterator) {
      return asyncIterator
    }
    var iterator = createIterator(source)
    if (iterator) {
      return new AsyncFromSyncIterator(iterator)
    }
  }
}

// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function AsyncFromSyncIterator(iterator) {
  this._i = iterator
}

// Note: all AsyncIterators are themselves AsyncIterable.
AsyncFromSyncIterator.prototype[$$asyncIterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
AsyncFromSyncIterator.prototype.next = function(value) {
  return unwrapAsyncFromSync(this._i, 'next', value)
}

AsyncFromSyncIterator.prototype.return = function(value) {
  return this._i.return
    ? unwrapAsyncFromSync(this._i, 'return', value)
    : Promise.resolve({ value: value, done: true })
}

AsyncFromSyncIterator.prototype.throw = function(value) {
  return this._i.throw
    ? unwrapAsyncFromSync(this._i, 'throw', value)
    : Promise.reject(value)
}

function unwrapAsyncFromSync(iterator, fn, value) {
  var step
  return new Promise(function(resolve) {
    step = iterator[fn](value)
    resolve(step.value)
  }).then(function(value) {
    return { value: value, done: step.done }
  })
}

/**
 * Given an object which either implements the AsyncIterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forAwaitEach` where you would expect to use a [for-await-of](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements) loop.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * > Note: Using `forAwaitEach` requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var forAwaitEach = require('iterall').forAwaitEach
 *
 * forAwaitEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES2017:
 * for await (let value of myAsyncIterable) {
 *   console.log(await doSomethingAsync(value))
 * }
 * console.log('done')
 *
 * // Any JavaScript environment:
 * forAwaitEach(myAsyncIterable, function (value) {
 *   return doSomethingAsync(value).then(console.log)
 * }).then(function () {
 *   console.log('done')
 * })
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<Promise<T> | T>|{ length: number }} source
 *   The AsyncIterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forAwaitEach:
  & (<+TValue, TCollection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>)
  & (<TCollection: { length: number }>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>); */
function forAwaitEach(source, callback, thisArg) {
  var asyncIterator = createAsyncIterator(source)
  if (asyncIterator) {
    var i = 0
    return new Promise(function(resolve, reject) {
      function next() {
        asyncIterator
          .next()
          .then(function(step) {
            if (!step.done) {
              Promise.resolve(callback.call(thisArg, step.value, i++, source))
                .then(next)
                .catch(reject)
            } else {
              resolve()
            }
            // Explicitly return null, silencing bluebird-style warnings.
            return null
          })
          .catch(reject)
        // Explicitly return null, silencing bluebird-style warnings.
        return null
      }
      next()
    })
  }
}


/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Apollo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apollo__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_client__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__ = __webpack_require__(170);





// import { persistCache } from 'apollo-cache-persist';

var Apollo = function Apollo() {
  // HTTP connection to the API
  var httpLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* createHttpLink */])({
    uri: "https://adminsensorless-dv.ponceautomations.com/admin/api"
  });

  var authLink = new __WEBPACK_IMPORTED_MODULE_3_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
    // Retrieve the authorization token from local storage.
    var token = localStorage.getItem('auth_token');

    // Use the setContext method to set the HTTP headers.
    operation.setContext({
      headers: {
        authorization: token ? 'Bearer ' + token : ''
      }
    });

    // Call the next link in the middleware chain.
    return forward(operation);
  });

  // Cache implementation
  var cache = new __WEBPACK_IMPORTED_MODULE_4_apollo_cache_inmemory__["a" /* InMemoryCache */]();

  // await before instantiating ApolloClient, else queries might run before the cache is persisted
  // persistCache({
  //   cache,
  //   storage: window.localStorage
  // });
  // Create the apollo client
  var apolloClient = new __WEBPACK_IMPORTED_MODULE_1_apollo_client__["a" /* ApolloClient */]({
    link: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_apollo_link__["b" /* concat */])(authLink, httpLink),
    cache: cache
  });

  var apolloProvider = new __WEBPACK_IMPORTED_MODULE_0_vue_apollo__["a" /* default */]({
    defaultClient: apolloClient
  });

  return apolloProvider;
};

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_persist__ = __webpack_require__(270);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var vuexLocal = new __WEBPACK_IMPORTED_MODULE_5_vuex_persist__["a" /* default */]({
  storage: window.localStorage,
  reducer: function reducer(state) {
    return { user: state.user, events: state.events };
  }
});

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    events: __WEBPACK_IMPORTED_MODULE_2__events__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_4__shared__["a" /* default */]
  },
  plugins: [vuexLocal.plugin]
});

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

module.exports = {
  STATES_LABELS: {
    irrigating: 'Regando',
    moving: 'Moviendo equipo',
    off: 'Apagado',
    failure: 'Equipo en falla'
  },
  STATES: {
    IRRIGATING: 'irrigating',
    MOVING: 'moving',
    OFF: 'off',
    FAILURE: 'failure'
  },
  COLOR: {
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    RED: '#ED1F24',
    GREEN: '#00d166',
    GREY: '#999',
    BLUE: '#4F5AB0'
  }
};

/***/ })

},[175]);


// WEBPACK FOOTER //
// static/js/app.895ea39ba982622115f8.js